module.exports = __webpack_public_path__ + "718cdfd9de81a1ef2368e0b6e5c88b0f.MP3";